import { jsx } from "react/jsx-runtime";
import { Icon } from "@contember/ui";
const DragHandle = () => {
  return /* @__PURE__ */ jsx(Icon, { blueprintIcon: "drag-handle-vertical" });
};
export {
  DragHandle
};
//# sourceMappingURL=DragHandle.js.map
